/* WildHer theme behaviour: cart drawer, AJAX add-to-cart, quantity,
   mobile menu, PDP gallery, and reveal-on-scroll. Vanilla JS, no deps. */
(function () {
  'use strict';

  const money = (cents) =>
    (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.whMoneyFormat)
      : '£' + (cents / 100).toFixed(2);

  /* ---- Cart drawer ----------------------------------------------------- */
  const drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() { if (drawer) { drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) { /* network — leave UI as-is */ }
  }

  function renderCart(cart) {
    const list = drawer && drawer.querySelector('[data-cart-items]');
    const sub = drawer && drawer.querySelector('[data-cart-subtotal]');
    const foot = drawer && drawer.querySelector('[data-cart-foot]');
    if (!list) return;

    if (!cart.items.length) {
      list.innerHTML = '<div class="wh-empty"><p>Your bag is empty.</p><a class="wh-btn wh-btn--primary wh-mt-l" href="/collections/all">Start shopping</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    list.innerHTML = cart.items.map((item) => `
      <div class="wh-line" data-key="${item.key}">
        <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') : ''}" alt="${item.product_title}" width="64" height="64" loading="lazy">
        <div>
          <div class="wh-line__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="wh-line__meta">${item.variant_title}</div>` : ''}
          <div class="wh-qty" data-qty>
            <button type="button" data-qty-dec aria-label="Decrease">−</button>
            <input type="text" inputmode="numeric" value="${item.quantity}" data-qty-input aria-label="Quantity">
            <button type="button" data-qty-inc aria-label="Increase">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div class="wh-price">${money(item.final_line_price)}</div>
          <button type="button" class="wh-line__meta" data-remove style="text-decoration:underline;margin-top:6px">Remove</button>
        </div>
      </div>
    `).join('');

    if (sub) sub.textContent = money(cart.items_subtotal_price);
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const cart = await res.json();
    renderCart(cart);
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  /* ---- Add to cart (AJAX) --------------------------------------------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true; }
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
      });
      await refreshCart();
      openDrawer();
    } catch (err) {
      form.submit(); // fall back to full page add
    } finally {
      if (btn) { btn.textContent = btn.dataset.label || 'Add to bag'; btn.disabled = false; }
    }
  });

  /* ---- Delegated clicks ----------------------------------------------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(); openDrawer(); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('.wh-drawer__scrim')) closeDrawer();

    const line = e.target.closest('.wh-line');
    if (line) {
      const key = line.dataset.key;
      const input = line.querySelector('[data-qty-input]');
      if (e.target.closest('[data-remove]')) { changeLine(key, 0); return; }
      if (e.target.closest('[data-qty-inc]')) { changeLine(key, parseInt(input.value, 10) + 1); return; }
      if (e.target.closest('[data-qty-dec]')) { changeLine(key, Math.max(0, parseInt(input.value, 10) - 1)); return; }
    }

    if (e.target.closest('[data-menu-toggle]')) {
      const nav = document.querySelector('[data-mobile-nav]');
      if (nav) {
        const willOpen = nav.hidden;
        nav.hidden = !willOpen;
        document.body.style.overflow = willOpen ? 'hidden' : '';
        document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.classList.toggle('is-open', willOpen));
      }
    }
    // close the overlay menu when a link inside it is clicked
    if (e.target.closest('[data-mobile-nav] a')) {
      const nav = document.querySelector('[data-mobile-nav]');
      if (nav) { nav.hidden = true; document.body.style.overflow = ''; }
      document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.classList.remove('is-open'));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawer();
      const nav = document.querySelector('[data-mobile-nav]');
      if (nav && !nav.hidden) { nav.hidden = true; document.body.style.overflow = ''; document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.classList.remove('is-open')); }
    }
  });

  /* ---- PDP gallery ----------------------------------------------------- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-pdp-thumb]');
    if (!thumb) return;
    const main = document.querySelector('[data-pdp-main]');
    if (main) main.src = thumb.dataset.full || thumb.src;
    // Mark which thumbnail is showing. Without this the gallery gives no sign
    // of where you are once there are more than two or three images.
    document.querySelectorAll('[data-pdp-thumb]').forEach((t) => {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* ---- Reveal on scroll ------------------------------------------------ */
  const reveals = document.querySelectorAll('.wh-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }
})();
